import { FunctionComponent } from 'react';

type EyeIconProps = {
  width?: number | string;
  height?: number | string;
  stroke?: string;
};

const EyeIcon: FunctionComponent<EyeIconProps> = ({
  width = 28,
  height = 18.523,
  stroke = '#151740',
}) => {
  return (
    <svg
      id="Group_119884"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 28 18.523"
    >
      <g id="Group_119883" transform="translate(0 0)">
        <g id="Path_111491" transform="translate(2)" fill="none">
          <path
            d="M12,0c6.443,0,10.862,4.947,14,9.261-3.374,4.639-7.557,9.261-14,9.261S.793,13.1-2,9.261C.751,5.479,5.557,0,12,0Z"
            fill="none"
          />
          <path
            d="M12 1.2C9.43 1.2 6.859 2.195 4.356 4.157 2.717 5.441 1.121 7.116 -0.506 9.261c1.64 2.164 3.241 3.846 4.876 5.126 2.489 1.948 5.056 2.935 7.629 2.935 5.543 0 9.31-3.787 12.509-8.062-1.23-1.637-2.951-3.716-5.003-5.299C17.096 2.104 14.641 1.2 12 1.2zm0-1.2c6.443 0 10.862 4.947 14 9.261-3.374 4.639-7.557 9.261-14 9.261S.793 13.1-2 9.261C.751 5.479 5.557 0 12 0z"
            fill={stroke}
          />
        </g>
        <g
          id="Ellipse_3906"
          transform="translate(7.44 2.701)"
          fill="none"
          stroke={stroke}
          strokeWidth={1.2}
        >
          <circle cx="6.56" cy="6.56" r="6.56" stroke="none" />
          <circle cx="6.56" cy="6.56" r="5.96" fill="none" />
        </g>
        <g
          id="Ellipse_3907"
          transform="translate(11.231 6.492)"
          fill="none"
          stroke={stroke}
          strokeWidth={1.2}
        >
          <circle cx="2.769" cy="2.769" r="2.769" stroke="none" />
          <circle cx="2.769" cy="2.769" r="2.169" fill="none" />
        </g>
      </g>
    </svg>
  );
};

export default EyeIcon;
